import * as React from 'react';
import './styles.scss';

interface ContainerProps {
  children: JSX.Element | JSX.Element[];
}

const Container = ({ children }: ContainerProps) => (
  <div className="container">
    {children}
  </div>
);

export default Container;
